import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import { faEye } from '@fortawesome/free-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import { px } from '../../../utils';
import { Button } from '../../Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var STRENGTH_TITLES = ['Very weak', 'Weak', 'Good', 'Strong', 'Very strong'];
var STRENGTH_STYLES = [
    { width: 0 },
    { width: '25%', backgroundColor: 'orange' },
    { width: '50%', backgroundColor: 'yellow' },
    { width: '75%', backgroundColor: 'green' },
    { width: '100%', backgroundColor: 'darkgreen' },
];
var PasswordStrengthContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding-bottom: ", ";\n\tposition: relative;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tfont-size: ", ";\n"], ["\n\tpadding-bottom: ", ";\n\tposition: relative;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tfont-size: ", ";\n"])), function (props) { return px(props.theme.space[1]); }, function (props) { return px(props.theme.space[2]); }, function (props) { return px(props.theme.space[3]); }, function (props) { return px(props.theme.fontSizes[0]); });
var ShowPasswordButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: ", ";\n\ttop: 50%;\n\ttransform: translate(0, -50%);\n"], ["\n\tposition: absolute;\n\tright: ", ";\n\ttop: 50%;\n\ttransform: translate(0, -50%);\n"])), function (props) { return px(props.theme.space[2]); });
var PasswordStrengthMeter = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\ttransition: all ease-out 150ms;\n\tposition: absolute;\n\theight: 4px;\n\tbackground-color: red;\n\tmin-width: 5px;\n\tbottom: 0;\n"], ["\n\ttransition: all ease-out 150ms;\n\tposition: absolute;\n\theight: 4px;\n\tbackground-color: red;\n\tmin-width: 5px;\n\tbottom: 0;\n"])));
var PasswordStrengthText = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin: 0;\n\tmargin-bottom: ", ";\n"], ["\n\tmargin: 0;\n\tmargin-bottom: ", ";\n"])), function (props) { return px(props.theme.space[2]); });
var PasswordStrength = function (_a) {
    var password = _a.password;
    var _b = React.useState(), strengthScore = _b[0], setStrengthScore = _b[1];
    React.useEffect(function () {
        var zxcvbn = window.zxcvbn;
        if (zxcvbn && password) {
            try {
                var score = zxcvbn(password).score;
                setStrengthScore(score);
            }
            catch (_a) {
            }
        }
    }, [password]);
    if (!password || strengthScore === undefined) {
        return null;
    }
    return (React.createElement(PasswordStrengthContainer, null,
        React.createElement(PasswordStrengthText, null,
            "Password strength: ",
            React.createElement("em", null, STRENGTH_TITLES[strengthScore])),
        React.createElement(PasswordStrengthMeter, { style: STRENGTH_STYLES[strengthScore] })));
};
var PasswordWidget = function (props) {
    var BaseInput = props.registry.widgets.BaseInput;
    var _a = React.useState(false), showPassword = _a[0], setShowPassword = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { position: 'relative' } },
            React.createElement(BaseInput, __assign({ pr: 4, type: showPassword ? 'text' : 'password' }, props)),
            React.createElement(ShowPasswordButton, { p: 2, plain: true, icon: React.createElement(FontAwesomeIcon, { fixedWidth: true, icon: showPassword ? faEye : faEyeSlash }), onClick: function () { return setShowPassword(function (x) { return !x; }); } })),
        props.options.showPasswordStrengthMeter && (React.createElement(PasswordStrength, { password: props.value }))));
};
export default PasswordWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
